// Map generated by scraping the RIS main website for exact profile URLs.
export const bioLinksMap = {
  "Professor Sachin Kumar Sharma": "https://www.ris.org.in/en/professor-sachin-kumar-sharma",
  "Professor Pami Dua": "https://www.ris.org.in/en/our-faculty/pami-dua",
  "Dr. Prabir De": "https://www.ris.org.in/en/dr-prabir-de",
  "Dr. P S Birthal": "https://www.ris.org.in/en/our-faculty/dr-ps-birthal",
  "Pratap Singh Birthal": "https://www.ris.org.in/en/our-faculty/dr-ps-birthal",
  "Dr. Pratap Singh Birthal": "https://www.ris.org.in/en/our-faculty/dr-ps-birthal",
  "Dr. Sabyasachi Saha": "https://www.ris.org.in/en/our-faculty/dr-sabyasachi-saha-associate-professor",
  "Dr. Priyadarshi Dash": "https://www.ris.org.in/en/dr-priyadarshi-dash-associate-professor",
  "Dr. Pankaj Vashisht": "https://www.ris.org.in/en/dr-pankaj-vashisht",
  "Dr. Amit Kumar": "https://www.ris.org.in/en/our-faculty/dr-amit-kumar",
  "Dr. Sushil Kumar": "https://www.ris.org.in/en/our-faculty/dr-sushil-kumar",
  "Dr. Pankhuri Gaur": "https://www.ris.org.in/en/our-faculty/dr-pankhuri-gaur",
  "Capt. Sarabjeet Singh Parmar": "https://www.ris.org.in/en/our-faculty/capt-sarabjeet-singh-parmar",
  "Ms. Krishna Bhattacharya": "https://www.ris.org.in/en/our-faculty/ms-krishna-bhattacharya",
  "Ms Krithika Manoj": "https://www.ris.org.in/en/our-faculty/krithika-manoj",
  "Mr Prateek Sharma": "https://www.ris.org.in/en/our-faculty/mr-prateek-sharma",
  "Mr Vaasu Aggarwal": "https://www.ris.org.in/en/vaasu-aggarwal",
  "Shri T K Ramachandran": "https://www.ris.org.in/en/our-faculty/shri-tk-ramachandran",
  "Dr. Shishir Shrotriya": "https://www.ris.org.in/en/shishir-shrotriya",
  "Dr. Jaswant Singh Kain": "https://www.ris.org.in/en/jaswant-singh-kain",
  "Mr. Pranshu Priyadarshi Birthal": "https://www.ris.org.in/en/our-faculty/mr-pranshu-priyadarshi-birthal",
  "Mr Pranshu P Birthal": "https://www.ris.org.in/en/our-faculty/mr-pranshu-priyadarshi-birthal",
  "Pranshu P Birthal": "https://www.ris.org.in/en/our-faculty/mr-pranshu-priyadarshi-birthal",
  "Ms. Anushka Tripathi": "https://www.ris.org.in/en/anushka-tripathi",
  "Ms Shagun Verma": "https://www.ris.org.in/en/shagun-verma",
  "Mr. Harshit Srivastava": "https://www.ris.org.in/en/our-faculty/mr-harshit-srivastava",
  "Ms Namita Mittal": "https://www.ris.org.in/en/namita-mittal",
  "Ms Deeksha Gupta": "https://www.ris.org.in/en/our-faculty/deeksha-gupta",
  "Dr. Amol Baxi": "https://www.ris.org.in/en/amol-baxi",
  "Cmde Sujeet Samaddar": "https://www.ris.org.in/en/sujeet-samaddar",
  "Mr. Anil Jauhri": "https://www.ris.org.in/en/our-faculty/anil-jauhri",
  "Dr. T.P. Rajendran": "https://www.ris.org.in/en/our-faculty/dr-tp-rajendran",
  "Mr. Amar Sinha": "https://www.ris.org.in/en/our-faculty/mr-amar-sinha-distinguished-fellow",
  "Dr. Kevin P. Gallagher": "https://www.ris.org.in/en/our-faculty/dr-kevin-p-gallagher",
  "Amb. Dr. Anil Sooklal": "https://www.ris.org.in/en/our-faculty/amb-dr-anil-sooklal",
  "Dr. Balakrishna Pisupati": "https://www.ris.org.in/en/our-faculty/dr-balakrishna-pisupati",
  "Prof. Suma Athreye": "https://www.ris.org.in/en/our-faculty/prof-suma-athreye",
  "Dr.Benu Schneider": "https://www.ris.org.in/en/our-faculty/drbenu-schneider",
  "Prof. Haribabu Ejnavarzala": "https://www.ris.org.in/en/our-faculty/prof-haribabu-ejnavarzala",
  "Prof. Manmohan Agarwal": "https://www.ris.org.in/en/our-faculty/prof-manmohan-agarwal",
  "Dr. Ganeshan Wignaraja": "https://www.ris.org.in/en/our-faculty/dr-ganeshan-wignaraja",
  "Dr. Srividhya Ragavan": "https://www.ris.org.in/en/our-faculty/dr-srividhya-ragavan",
  "Prof. Mukul G. Asher": "https://www.ris.org.in/en/our-faculty/prof-mukul-g-asher",
  "Dr. Nicolas J.A. Buchoud": "https://www.ris.org.in/en/nicolas-JA-buchoud",
  "Dr. Satish Chandra Mishra": "https://www.ris.org.in/en/satish-chandra-mishra",
  "Dr. Rahul Sen": "https://www.ris.org.in/en/our-faculty/dr-rahul-sen",
  "Prof. K G Suresh": "https://www.ris.org.in/en/our-faculty/prof-k-g-suresh",
  "Shri Rakesh Khar": "https://www.ris.org.in/en/our-faculty/shri-rakesh-khar",
  "Dr. Rajan Sudesh Ratna": "https://www.ris.org.in/en/our-faculty/dr-rajan-sudesh-ratna",
  "Dr. Atul Kaushik": "https://www.ris.org.in/en/our-faculty/dr-atul-kaushik",
  "Dr. Monika Kochar": "https://www.ris.org.in/en/dr-monika-kochar",
  "Dr. Monika Kochhar": "https://www.ris.org.in/en/dr-monika-kochar",
  "Dr. Araypalli Sivasenareddy": "https://www.ris.org.in/en/araypalli-sivasenareddy",
  "Mr. Amit Arora": "https://www.ris.org.in/en/mr-amit-arora",
  "Mr. Omegere John Patrick": "https://www.ris.org.in/en/omegere-john-patrick",
  "Ms. Tanya Singh": "https://www.ris.org.in/en/tanya-singh",
  "Dr. Anshuman Gupta": "https://www.ris.org.in/en/our-faculty/anshuman-gupta",
  "Dr. Sneha Sinha": "https://www.ris.org.in/en/our-faculty/ms-sneha-sinha",
  "Dr. Sayantan Ghosal": "https://www.ris.org.in/en/our-faculty/mr-sayantan-ghosal",
  "Dr. Sarin N.S.": "https://www.ris.org.in/en/sarin-nambeeshan-sasikumar",
  "Dr. Sanket chavan": "https://www.ris.org.in/en/sanket-chavan",
  "Dr. Sanjeev Kumar Varshney": "https://www.ris.org.in/en/our-faculty/dr-sanjeev-kumar-varshney",
  "Mr. Aathik Mohamed M": "https://www.ris.org.in/en/aathik-mohamed",
  "Dr. Renu Mann": "https://www.ris.org.in/en/our-faculty/dr-renu",
  "Ms. Renu": "https://www.ris.org.in/en/our-faculty/dr-renu",
  "Renu": "https://www.ris.org.in/en/our-faculty/dr-renu",
  "Ms. Paavni Mathur": "https://www.ris.org.in/en/our-faculty/paavni-mathur",
  "Ms. Lakshmi Swathi Ganti": "https://www.ris.org.in/en/our-faculty/lakshmi-swathi-ganti",
  "Ms. Alisha Goswami": "https://www.ris.org.in/en/our-faculty/alisha-goswami",
  "Mr. Pragyan Deep Aggarwal": "https://www.ris.org.in/en/our-faculty/mr-pragyan-deep-aggarwal",
  "Pragyan": "https://www.ris.org.in/en/our-faculty/mr-pragyan-deep-aggarwal",
  "Pragyan Deep Aggarwal": "https://www.ris.org.in/en/our-faculty/mr-pragyan-deep-aggarwal",
  "Dr. Adrija Ganguly": "https://www.ris.org.in/en/our-faculty/ms-adrija-ganguly",
  "Mr. Jamshed Ahmad Siddiqui": "https://www.ris.org.in/en/our-faculty/mr-jamshed-ahmad-siddiqui",
  "Jamshed": "https://www.ris.org.in/en/our-faculty/mr-jamshed-ahmad-siddiqui",
  "Jamshed Siddiqui": "https://www.ris.org.in/en/our-faculty/mr-jamshed-ahmad-siddiqui",
  "Jamshed Ahmad Siddiqui": "https://www.ris.org.in/en/our-faculty/mr-jamshed-ahmad-siddiqui",
  "Mr. Krishan Pal": "https://www.ris.org.in/en/our-faculty/mr-krishan-pal",
  "Mr Vikash Ranjan": "https://www.ris.org.in/en/our-faculty/mr-vikash-ranjan",
  "Dr. P. Srinivasa Rao": "https://www.ris.org.in/en/srinivasa-rao",
  "Ms. Om Stutee": "https://www.ris.org.in/en/om-stutee",
  "Mr. Ayush Tiwari": "https://www.ris.org.in/en/ayush-tiwari",
  "Mr. Kanishk Rohilla": "https://www.ris.org.in/en/kanishk-rohilla",
  "Mr. Avinash": "https://www.ris.org.in/en/avinash",
  "Ms. Riddhi Lakhiani": "https://www.ris.org.in/en/riddhi-lakhiani",
  "Ms. Vanshika Goyal": "https://www.ris.org.in/en/vanshika-goyal",
  "Ms. Tushti Tanwar": "https://www.ris.org.in/en/tushti-tanwar",
  "Ms. Shri Nidhi Pareek": "https://www.ris.org.in/en/nidhi-pareek",
  "Ms. Tanya Malhotra": "https://www.ris.org.in/en/our-faculty/tanya-malhotra",
  "Ms. Ishita Verma": "https://www.ris.org.in/en/our-faculty/ishita-verma",
  "Mr. Sankalan Dey": "https://www.ris.org.in/en/our-faculty/mr-sankalan-dey",
  "Mr. Anil Kant Sharma": "https://www.ris.org.in/node/3716",
  "Mr Arijit Banerjee": "https://www.ris.org.in/node/3961",
  "Ms Ritu Parnami": "https://www.ris.org.in/node/178",
  "Mrs. Ritu": "https://www.ris.org.in/node/178",
  "Mr. Sachin Singhal": "https://www.ris.org.in/node/185",
  "Mr. Sanjeev Kumar Karna": "https://www.ris.org.in/node/189",
  "Sanjay Singh": "https://www.ris.org.in/node/4287",
  "Karanpreet Kaur Sodhi": "https://www.ris.org.in/node/4320",
  "Mr Rajeev": "https://www.ris.org.in/node/4518",
  "Mrs. Jyoti": "https://www.ris.org.in/node/90",
  "Mrs. Sushila": "https://www.ris.org.in/node/179",
  "Mr. Sudhir Rana": "https://www.ris.org.in/node/180",
  "Mrs. Sushma Bhat": "https://www.ris.org.in/node/91",
  "Mr. Satya Pal Singh Rawat": "https://www.ris.org.in/node/182",
  "Mrs. Nisha Saini": "https://www.ris.org.in/node/184",
  "Mr. Durga Prasad Singh": "https://www.ris.org.in/node/4158",
  "Mr. Anil Kumar": "https://www.ris.org.in/node/194",
  "Mrs. Shalini Sharma": "https://www.ris.org.in/node/198",
  "Mr. Baidnath Pandey": "https://www.ris.org.in/node/196",
  "Amarendra Pattanayak": "https://www.ris.org.in/node/4284",
  "Mr. Yogesh": "https://www.ris.org.in/node/3835",
  "Mr. Parmod Kumar": "https://www.ris.org.in/node/4301",
  "Mr. Piyush Mathur": "https://www.ris.org.in/node/3836",
  "Mr. Bhaskar Tiwari": "https://www.ris.org.in/node/3325",
  "Mr. Surender Kumar": "https://www.ris.org.in/node/201",
  "Mrs. Bindu Gambhir": "https://www.ris.org.in/node/202",
  "Mrs. Gohar Naaz": "https://www.ris.org.in/node/207",
  "Mr. Baljit": "https://www.ris.org.in/node/3544",
  "Ms. Kiran Wagh": "https://www.ris.org.in/node/199",
  "Mr. J.B. Thakuri": "https://www.ris.org.in/node/212",
  "Mr. Raju": "https://www.ris.org.in/node/215",
  "Mr. Pradeep": "https://www.ris.org.in/node/214",
  "Mr. Manish Kumar": "https://www.ris.org.in/node/217",
  "Mr. Raj Kumar Sagar": "https://www.ris.org.in/node/218",
  "Mr. Avinash Kapoor": "https://www.ris.org.in/node/3545",
  "Mr. Ramesh Singh Choudhary": "https://www.ris.org.in/node/4285",
  "Mr. Rishi Bagga": "https://www.ris.org.in/node/4302",
  "Mr Dinesh": "https://www.ris.org.in/node/4425"
};

/**
 * Normalizes a name string for fuzzy matching (removes titles, extra spaces, and lowercase)
 */
const normalizeName = (name) => {
    if (!name) return '';
    return name.replace(/^(Dr\.|Mr\.|Ms\.|Mrs\.|Prof\.|Shri|Smt\.|Mr|Ms|Mrs|Dr|Prof|Capt\.|Amb\.|Cmde)\s+/i, '')
               .replace(/[^a-zA-Z0-9]/g, '')
               .toLowerCase();
};

// Create a normalized lookup map for robustness
const normalizedMap = {};
for (const [key, value] of Object.entries(bioLinksMap)) {
    normalizedMap[normalizeName(key)] = value;
}

/**
 * Returns the correct bio URL for a given name if found, otherwise generates a fallback slug.
 */
export const getBioLink = (name) => {
    if (!name) return '#';
    
    // Exact match
    if (bioLinksMap[name]) {
        return bioLinksMap[name];
    }
    
    // Fuzzy match
    const norm = normalizeName(name);
    if (normalizedMap[norm]) {
        return normalizedMap[norm];
    }
    
    // Fallback: Generate the standard RIS slug if we didn't scrape it
    let cleanName = name.replace(/^(Dr\.|Mr\.|Ms\.|Mrs\.|Prof\.|Shri|Smt\.|Mr|Ms|Mrs|Dr|Prof|Capt\.|Amb\.|Cmde)\s+/i, '');
    const slug = cleanName.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-');
    return `https://www.ris.org.in/en/${slug}`;
};
